import React from "react";
import "./CancelModal.css";

const ConfirmCancelModal = ({ show, onYes, onNo }) => {
  if (!show) return null;

  return (
    <div className="modal-backdrop-custom">
      <div className="confirm-box">
        <button className="close-btn top-right" onClick={onNo}>×</button>

        <p className="confirm-text">
          Are you sure you want to <br /> cancel this Order?
        </p>

        <div className="confirm-actions">
          <button className="btn-yes" onClick={onYes}>Yes</button>
          <button className="btn-no" onClick={onNo}>No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCancelModal;
